import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { DialogHaloCardsComponent } from './dialog-halo-cards.component';
import { SharedModules } from '../../shared.modules';
import { CardModule } from '../card/card.module';

@NgModule({
  declarations: [DialogHaloCardsComponent],
  imports: [
    CommonModule,
    SharedModules,
    CardModule
  ],
  exports: [DialogHaloCardsComponent]
})
export class DialogHaloCardsModule { }
